import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;

@Component({
  selector: 'app-asset-stock-point',
  templateUrl: './asset-stock-point.component.html',
  styleUrls: ['./asset-stock-point.component.css']
})
export class AssetStockPointComponent implements OnInit {


  singleObjectInfoData: any[] = [];
  objectTemplateId: string = "";
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: number[] = [3, 6, 9, 12];

  cid: string | null = null;
  groupTypeList: any[] = [];
  objectInfoList: any[] = [];
  objectInfoListFilter: any[] = [];
  singleObjectTemplateData: any[] = [];
  objectTemplateList: any[] = [];

  isLoading: boolean = false;
  showFilter: boolean = false;
  searchFilter: string = "";
  recordName: string = "";
  recordId: string = "";
  selectedTemplate: string = "";
  showLocationList: boolean = false;
  selectedLocations: string[] = [];
  maintenanceScheduleList: any[] = [];

  maintenanceType = [
    { key: "Preventive Maintenance (PM) Schedule", value: "PreventiveMaintenanceSchedule" },
    { key: "Corrective Maintenance Schedule", value: "CorrectiveMaintenanceSchedule" },
    { key: "Predictive Maintenance Schedule", value: "PredictiveMaintenanceSchedule" },
    { key: "Condition-Based Maintenance (CBM)", value: "ConditionBasedMaintenance" }
  ];

  imagesList: any[] = [];
  imagesWithDetails: any[] = [];
  largeImage: string = "";
  template: any;
  objectInfo: any;
  objectTemplate: any;
  objectInfoListWithPagination: any[] = [];
  userLocations: any[] = [];
  locationList: any[] = [];
  locationFilterList: any[] = [];
  userCred: any;

  sortOrders = { location: 'asc', branch: 'asc' };
  jsonString: string = "";

  viewMode: 'table' | 'map' | 'card' = 'table';
  cardCurrentPage: number = 1;
  cardsPerPage: number = 8;

  get paginatedCards() {
    const start = (this.cardCurrentPage - 1) * this.cardsPerPage;
    return this.objectInfoList.slice(start, start + this.cardsPerPage);
  }

  nextCardPage() {
    if (this.cardCurrentPage * this.cardsPerPage < this.objectInfoList.length) {
      this.cardCurrentPage++;
    }
  }

  prevCardPage() {
    if (this.cardCurrentPage > 1) {
      this.cardCurrentPage--;
    }
  }

  setViewMode(mode: 'table' | 'map' | 'card') {
    this.viewMode = mode;
    this.mapView = mode === 'map';
    if (this.mapView) {
      this.initMap();
    }
  }

  mapView: boolean = false;
  map: any;
  defaultCenter: [number, number] = [17.4065, 78.4772];
  defaultZoom: number = 14;

  constructor(private toastr: ToastrService, private generic_service: GenericService) { }

  async ngOnInit(): Promise<void> {
    this.cid = sessionStorage.getItem('cid');
    const creds = sessionStorage.getItem('userCreds');
    this.userCred = creds ? JSON.parse(creds) : null;
    this.getAllLocation();
  }

  getAllObjectInfoByLocationsAndCid() {
    const body = {
      "location": this.selectedLocations || [],
      "version": 0,
      "isActive": true,
      "description": "",
      "pageNo": 0,
      "recordsPerPage": 0
    };
    console.log(body);
    this.isLoading = true;
    this.generic_service.getAllObjectInfoByLocationsAndCid(body).subscribe(
      (response: any) => {
        console.log(response);
        this.objectInfoList = response.response || [];
        this.count = response.response?.length || 0;
        this.isLoading = false;
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error fetching object info', error)
      }

    );
  }

  handleStoredTemplate(): void {
    const storedTemplate = localStorage.getItem('template');
    if (storedTemplate) {
      this.template = JSON.parse(storedTemplate);
      this.getObjectInfoByTemplateNameAndLocations(this.template?.templateName || '');
      this.showFilter = true;
      localStorage.removeItem('template');
    } else {
      this.template = null;
      this.getAllObjectInfoByLocationsAndCid();
    }
  }

  selectLargeImage(largeImage: string): void {
    this.largeImage = largeImage;
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
  }

  refreshTickets(): void {
    this.page = 1;
    this.first = 0;
    this.searchFilter = "";
    this.showFilter = false;
    this.selectedTemplate = "";
    this.selectedLocations = [...this.userLocations];
    this.mapView = false;
    this.viewMode = 'table';
    this.cardCurrentPage = 1;
    this.getAllObjectInfoByAllTemplateAndLocationsCounts();
    this.getAllObjectInfoByLocationsAndCid();
  }

  closeModal(): void {
    this.recordId = "";
    this.recordName = "";
  }

  onTableDataChange(event: any): void {
    this.page = event.page + 1;
  }

  getAllObjectTemplate(): void {
    this.generic_service.getAllObjectInfoByAllTemplateCounts().subscribe(
      (response: any) => {
        this.objectTemplateList = (response.response || []).filter((list: any) => !!list.templateName);
      },
      (error: any) => console.error('Error fetching object template', error)
    );
  }

  getObjectTemplateById(event: any): void {
    this.generic_service.getObjectTemplateById(event.target.value).subscribe(
      (response: any) => {
        this.singleObjectTemplateData = [response.response];
      },
      (error: any) => console.error('Error fetching template by ID', error)
    );
  }

  getMaintenanceType(type: string): string {
    const found = this.maintenanceType.find(list => list.value === type);
    return found ? found.key : "";
  }

  getObjectInfoById(id: string): void {
    this.generic_service.getObjectInfoById(id).subscribe(
      (response: any) => {
        const data = response.response;
        this.singleObjectInfoData = [data];
        this.imagesList = data?.images || [];
        this.imagesWithDetails = data?.imagesWithDetails || [];
        this.getAllMaintenanceScheduleByAssetId(id);

        this.jsonString = JSON.stringify({
          "Id": data?.objectInfoId || "",
          "Name": data?.givenName || "",
          "Condition": data?.objectCondition || "",
        });
      },
      (error: any) => console.error('Error fetching object info by ID', error)
    );
  }

  getAllObjectInfo(): void {
    this.generic_service.getAllObjectInfo().subscribe(
      (response: any) => {
        this.objectInfoList = response.response || [];
        this.objectInfoListFilter = response.response || [];
        this.count = this.objectInfoList.length;
      },
      (error: any) => console.error('Error fetching object info', error)
    );
  }

  sortByLocation(): void {
    const order = this.sortOrders.location;
    this.objectInfoList = [...this.objectInfoListFilter].sort((a: any, b: any) => {
      const locA = a.location?.toLowerCase() || '';
      const locB = b.location?.toLowerCase() || '';
      if (locA < locB) return order === 'asc' ? -1 : 1;
      if (locA > locB) return order === 'asc' ? 1 : -1;
      return 0;
    });
    this.sortOrders.location = order === 'asc' ? 'desc' : 'asc';
  }

  sortByBranch(): void {
    const order = this.sortOrders.branch;
    this.objectInfoList = [...this.objectInfoListFilter].sort((a: any, b: any) => {
      const branchA = a.branch?.toLowerCase() || '';
      const branchB = b.branch?.toLowerCase() || '';
      if (branchA < branchB) return order === 'asc' ? -1 : 1;
      if (branchA > branchB) return order === 'asc' ? 1 : -1;
      return 0;
    });
    this.sortOrders.branch = order === 'asc' ? 'desc' : 'asc';
  }

  remove(): void {
    document.getElementById("closeModalButton")?.click();
    this.singleObjectTemplateData = [];
    this.objectTemplateId = "";
  }

  selectDelete(id: string, record: any): void {
    this.objectTemplateId = id;
    this.recordId = record.objectInfoId;
    this.recordName = record.givenName;
  }

  deleteAsset(): void {
    this.generic_service.deleteObjectInfo(this.objectTemplateId).subscribe(
      (response: any) => {
        document.getElementById("deleteModalButton1")?.click();
        this.getAllObjectInfo();
        this.toastr.success(response.message);
      },
      (error: any) => {
        console.error('Error deleting asset', error);
        if (error?.errors?.length) {
          this.toastr.error(error.errors[0].description);
        }
      }
    );
  }

  getAllLocation(): void {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        console.log(res)
        this.locationList = res.response || [];
        this.locationFilterList = this.locationList.filter((location: any) =>
          location.stockPoint == true
        ) || [];
        console.log(this.locationFilterList);

        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
        console.log(this.userLocations);
        this.selectedLocations = [...this.userLocations];
        this.getAllObjectInfoByAllTemplateAndLocationsCounts();
        this.handleStoredTemplate();

      },
      (err: any) => console.error('Error fetching locations', err)
    );
  }

  getAllObjectInfoByAllTemplateAndLocationsCounts(): void {
    const body = {
      "template": "",
      "location": this.selectedLocations || []
    };

    this.generic_service.getAllObjectInfoByAllTemplateAndLocationsCounts(body).subscribe(
      (response: any) => {
        this.objectTemplateList = response.response || [];
      },
      (error: any) => console.error('Error fetching template counts', error)
    );
  }

  getAllObjectInfoWithPaginationAndLocation(pageNumber: number, recordsPerPage: number): void {
    const body = {
      "location": this.selectedLocations || [],
      "pageNo": pageNumber,
      "recordsPerPage": recordsPerPage,
    };

    this.isLoading = true;
    this.generic_service.getAllObjectInfoWithPaginationAndLocation(body).subscribe(
      (response: any) => {
        this.objectInfoListWithPagination = response.response?.objectInfoList || [];
        this.count = response.response?.totalRecords || 0;
        this.isLoading = false;
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error with pagination', error);
      }
    );
  }

  getObjectInfoByTemplateNameAndLocations(templateName: string): void {
    this.isLoading = true;
    this.selectedTemplate = templateName;

    const body = {
      "template": templateName,
      "location": this.selectedLocations || []
    };

    this.generic_service.getObjectInfoByTemplateNameAndLocations(body).subscribe(
      (response: any) => {
        this.objectInfoList = response.response || [];
        this.count = this.objectInfoList.length;
        this.page = 1;
        this.first = 0;
        this.isLoading = false;
        if (this.mapView) this.initMap();
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error fetching info by template name', error);
      }
    );
  }

  toggleLocationSelection(loc: string): void {
    const index = this.selectedLocations.indexOf(loc);
    if (index > -1) {
      this.selectedLocations.splice(index, 1);
    } else {
      this.selectedLocations.push(loc);
    }
    this.refreshDataBasedOnLocation();
  }

  selectAllLocations(): void {
    this.selectedLocations = [...this.userLocations];
    this.refreshDataBasedOnLocation();
  }

  unselectAllLocations(): void {
    this.selectedLocations = [];
    this.refreshDataBasedOnLocation();
  }

  private refreshDataBasedOnLocation(): void {
    this.getAllObjectInfoByAllTemplateAndLocationsCounts();
    if (this.selectedTemplate) {
      this.getObjectInfoByTemplateNameAndLocations(this.selectedTemplate);
    } else {
      this.getAllObjectInfoByLocationsAndCid();
    }
  }

  filter(name: string): void {
    if (this.mapView) this.initMap();
  }

  getAllMaintenanceScheduleByAssetId(objectInfoId: string): void {
    this.generic_service.getAllMaintenanceScheduleByAssetId(objectInfoId).subscribe(
      (response: any) => {
        this.maintenanceScheduleList = response.response || [];
      },
      (error: any) => console.error('Error fetching maintenance schedule', error)
    );
  }

  getObjectInfoByWildSearch(): void {
    if (!this.searchFilter) return;

    this.generic_service.getObjectInfoByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        this.objectInfoList = res.response || [];
        this.count = this.objectInfoList.length;
        this.page = 1;
        this.first = 0;
        this.cardCurrentPage = 1;
        this.isLoading = false;
        if (this.mapView) this.initMap();
      },
      (err: any) => console.error('Serial Number Error:', err)
    );
  }

  mapToggle(): void {
    this.mapView = !this.mapView;
    if (this.mapView) this.initMap();
  }

  private initMap(): void {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }

    setTimeout(() => {
      this.map = L.map('map', {
        center: this.defaultCenter,
        zoom: this.defaultZoom
      });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 22,
        minZoom: 2,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(this.map);

      this.plotMarkers();
    }, 100);
  }

  private plotMarkers(): void {
    for (const obj of this.objectInfoList) {
      if (!obj.multiLatLng && obj.lat && obj.lat !== 0) {
        const iconUrl = obj.icon || 'assets/image (1).png';
        const customHtmlIcon = L.divIcon({
          className: '',
          html: `
            <div style="position: relative; width: 60px; height: 60px; background: white; border: 3px solid rgb(196, 192, 192); border-radius: 50%; overflow: hidden;">
              <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
              <div style="position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%); border-left: 10px solid transparent; border-right: 10px solid transparent;"></div>
            </div>
          `,
          iconAnchor: [30, 30],
          popupAnchor: [0, 0]
        });

        L.marker([obj.lat, obj.lng], { icon: customHtmlIcon })
          .addTo(this.map)
          .on('click', () => {
            this.getObjectInfoById(obj.objectInfoId);
            document.getElementById('hiddenViewModalBtn')?.click();
          });
      } else if (obj.area?.length) {
        const latlngs = obj.area.map((p: any) => [parseFloat(p.lng), parseFloat(p.lat)]);
        const feature = {
          type: "Feature",
          color: obj.objectColorCode || 'black',
          properties: obj,
          geometry: {
            type: "LineString",
            coordinates: latlngs
          }
        };

        L.geoJSON(feature as any, {
          style: { color: feature.color, weight: 10 }
        }).addTo(this.map)
          .on('click', () => {
            this.getObjectInfoById(obj.objectInfoId);
            document.getElementById('hiddenViewModalBtn')?.click();
          });
      }
    }

    if (this.objectInfoList.length > 0) {
      const latLngs = this.objectInfoList
        .filter(item => item.lat && item.lng)
        .map(item => [item.lat, item.lng] as L.LatLngExpression);

      if (latLngs.length > 0) {
        const bounds = L.latLngBounds(latLngs);
        this.map.fitBounds(bounds, { padding: [20, 20], maxZoom: 12 });
        this.map.invalidateSize();
      }
    }
  }

}